export const KIND_OPTIONS = ["BASE", "ADJUST", "OVERRIDE"];

export const KIND_CONFIG = {
  BASE: { label: "Base", className: "bg-gray-100 text-gray-700 ring-gray-200" },
  ADJUST: { label: "Adjust", className: "bg-blue-100 text-blue-700 ring-blue-200" },
  OVERRIDE: { label: "Override", className: "bg-amber-100 text-amber-800 ring-amber-200" },
};

const TAG_PALETTES = [
  "bg-blue-100 text-blue-700 ring-blue-200",
  "bg-violet-100 text-violet-700 ring-violet-200",
  "bg-emerald-100 text-emerald-700 ring-emerald-200",
  "bg-amber-100 text-amber-800 ring-amber-200",
  "bg-rose-100 text-rose-700 ring-rose-200",
  "bg-cyan-100 text-cyan-700 ring-cyan-200",
  "bg-orange-100 text-orange-800 ring-orange-200",
  "bg-pink-100 text-pink-700 ring-pink-200",
  "bg-teal-100 text-teal-700 ring-teal-200",
  "bg-indigo-100 text-indigo-700 ring-indigo-200",
];

export function tagPalette(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return TAG_PALETTES[Math.abs(hash) % TAG_PALETTES.length];
}

export const CONDITION_FIELDS = [
  { key: "customerName", label: "Customer Name", type: "text" },
  { key: "companyName", label: "Company Name", type: "text" },
  { key: "toName", label: "To Name", type: "text" },
  { key: "storeName", label: "Store Name", type: "text" },
  { key: "state", label: "State", type: "text" },
  { key: "postcode", label: "Postcode", type: "text" },
  { key: "carrier", label: "Carrier", type: "text" },
  { key: "serviceType", label: "Service Type", type: "text" },
  { key: "weight", label: "Weight", type: "number" },
  { key: "despatchDate", label: "Despatch Date", type: "date" },
  { key: "dangerousGoods", label: "Dangerous Goods", type: "bool" },
  { key: "handUnloading", label: "Hand Unloading", type: "bool" },
  { key: "tailLiftRequired", label: "Tail Lift Required", type: "bool" },
  { key: "appointmentRequired", label: "Appointment Required", type: "bool" },
];

export const OPERATOR_OPTIONS = {
  text: [
    { value: "eq", label: "Equals" },
    { value: "contains", label: "Contains" },
    { value: "starts_with", label: "Starts With" },
    { value: "ends_with", label: "Ends With" },
    { value: "neq", label: "Not Equal" },
  ],
  number: [
    { value: "eq", label: "=" },
    { value: "gt", label: ">" },
    { value: "gte", label: ">=" },
    { value: "lt", label: "<" },
    { value: "lte", label: "<=" },
  ],
  date: [
    { value: "on", label: "On Date" },
    { value: "on_or_after", label: "On/After" },
    { value: "on_or_before", label: "On/Before" },
  ],
  bool: [{ value: "eq", label: "Is" }],
};

export const FIELD_LABEL = CONDITION_FIELDS.reduce((acc, f) => {
  acc[f.key] = f.label;
  return acc;
}, {});

export const OPERATOR_LABEL = Object.values(OPERATOR_OPTIONS)
  .flat()
  .reduce((acc, op) => {
    if (!acc[op.value]) acc[op.value] = op.label;
    return acc;
  }, {});

export const OPERATOR_READABLE = {
  eq: "=",
  neq: "!=",
  contains: "contains",
  starts_with: "starts with",
  ends_with: "ends with",
  gt: ">",
  gte: ">=",
  lt: "<",
  lte: "<=",
  on: "on",
  on_or_after: "on or after",
  on_or_before: "on or before",
};

export const CONDITION_TYPE_BY_FIELD = CONDITION_FIELDS.reduce((acc, f) => {
  acc[f.key] = f.type;
  return acc;
}, {});

export const initialRuleForm = {
  name: "",
  kind: "ADJUST",
  days: 1,
  priority: 500,
  isActive: true,
  stopProcessing: false,
  reason: "",
  notes: "",
  tags: [],
};

export const initialConsignment = {
  customerName: "",
  companyName: "",
  toName: "",
  storeName: "",
  state: "",
  postcode: "",
  carrier: "",
  serviceType: "",
  weight: "",
  despatchDate: "",
  dangerousGoods: false,
  handUnloading: false,
  tailLiftRequired: false,
  appointmentRequired: false,
};

export const initialColumnFilters = {
  priority: "",
  name: "",
  kind: "",
  days: "",
  tags: "",
  conditions: "",
  status: "all",
};
